/**
 * @generated SignedSource<<5c1818ce7a23d3b0a81aa69562027e23>>
 * @relayHash 10166dc20f14f85023184a63fbb2cb86
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f6799c75f0593a211d850a554522a04042513ce147864e7519f18ea76df5583

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { HorizontalNavJiraInnerQuery } from './HorizontalNavJiraInnerQuery.graphql';

import isJiraCustomTemplatesUxEnabled_provider from '@atlassian/jira-relay-provider/src/jira-custom-templates-ux-fg.relayprovider';
import showInviteButton_provider from '@atlassian/jira-relay-provider/src/jira-invite-button.relayprovider';
import shouldFetchProjectAccess_provider from '@atlassian/jira-relay-provider/src/jira-is-fetch-accesslevel-for-split-share-button-enabled.relayprovider';
import fetchTeamCount_provider from '@atlassian/jira-relay-provider/src/jira-team-button-team-count.relayprovider';

const node: PreloadableConcreteRequest<HorizontalNavJiraInnerQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8f6799c75f0593a211d850a554522a04042513ce147864e7519f18ea76df5583",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiracustomtemplatesuxfgrelayprovider": isJiraCustomTemplatesUxEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider": showInviteButton_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirateambuttonteamcountrelayprovider": fetchTeamCount_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiraisfetchaccesslevelforsplitsharebuttonenabledrelayprovider": shouldFetchProjectAccess_provider
    }
  }
};

export default node;
